import { isly } from "isly";
export var Digit;
(function (Digit) {
    var _a;
    Digit.values = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    _a = isly.string("value", Digit.values).rename("isoly.Digit").bind(), Digit.type = _a.type, Digit.is = _a.is, Digit.flawed = _a.flawed;
})(Digit || (Digit = {}));
//# sourceMappingURL=index.js.map